export default __webpack_public_path__ + "static/media/MANDU.b32752a9.jpg";